import { SupportedLocale, dateString } from "util/dates";
import { formatPurchaseAmount } from "../util/formatters";

import { Column } from "react-migration/components/TableDeprecated";
import { DescriptionCell } from "../components/DescriptionCell";
import { Transaction } from "../../typings/TransactionsResponse";
import { i18n } from "src/js/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { TransactionTypeCell } from "../components/TransactionTypeCell";

export const useDocumentColumns = () => {
  const { t } = useTranslation();

  return useMemo<Column<Transaction>[]>(
    () => [
      {
        label: t("dashboard.transactions.date"),
        render: ({ created }) => (created ? dateString(created, i18n.locale as SupportedLocale) : ""),
        grow: true,
      },
      {
        label: t("dashboard.transactions.transaction_type"),
        render: (transaction) => <TransactionTypeCell transaction={transaction} />,
        grow: true,
      },
      {
        label: t("dashboard.transactions.description"),
        render: (transacton) => <DescriptionCell transaction={transacton} />,
        grow: true,
      },
      {
        label: t("dashboard.transactions.user"),
        render: ({ user }) => (user?.firstname && user?.surname ? `${user.firstname} ${user.surname}` : "unknown user"),
        grow: true,
      },
      {
        label: t("dashboard.transactions.purchase_method"),
        render: ({ purchaseMethod }) =>
          purchaseMethod === "HMLR_ACCOUNT"
            ? t("dashboard.transactions.purchase_method.hmlr")
            : t("dashboard.transactions.purchase_method.balance"),
        grow: true,
      },
      {
        label: t("dashboard.transactions.balance_difference"),
        render: (transaction) => formatPurchaseAmount(transaction),
        grow: true,
        align: "right",
      },
    ],
    [t]
  );
};
